<template>
  <v-navigation-drawer
    app
    :touchless="!mobile && !tablet"
    :value="open"
    @input="(value) => $emit('close', value)"
    class="elevation-2 navigation-drawer"
  >
    <template v-slot:prepend>
      <v-list-item class="logo-container">
        <v-row class="logo-wrapper">
          <logo :url="logoUrl" />
        </v-row>
      </v-list-item>
    </template>
    <v-divider />
    <v-list v-if="items" :class="{ 'navigation-items-short': hasCustomLogo }">
      <navigation-item
        v-for="item in items"
        :navigation-item="item"
        :key="item.title"
      />
      <template v-if="hasCustomLogo">
        <bottom-logo />
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import NavigationItem from "Components/NavigationDrawer/components/NavigationItem";
import BottomLogo from "Public/components/SideNav/BottomLogo";
import Logo from "./components/Logo";
import checkMobileMixin from "Shared/mixins/checkMobileMixin";
import checkTabletMixin from "Shared/mixins/checkTabletMixin";
export default {
  name: "NavigationDrawer",
  components: { Logo, BottomLogo, NavigationItem },
  mixins: [checkMobileMixin, checkTabletMixin],
  props: {
    open: {
      type: Boolean,
      default: true,
    },
    logoUrl: {
      type: String,
      default: "/-/public/img/logo.png",
    },
    items: {
      type: Array | undefined,
      required: true,
    },
    hasCustomLogo: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.logo-wrapper {
  margin: 5px 0 !important;
  justify-content: center;
}

.logo-container {
  width: 100%;
  padding: 0 !important;
}

.navigation-items-short {
  max-height: 80vh;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
